<template>
	<!-- 添加奖励领取成功弹窗 -->
	<!-- 修改烟花容器的位置和结构 -->
	<div class="reward-modal" v-if="showRewardModal" @click.self="closeRewardModal">
		<!-- 将烟花容器移到这里，使其覆盖整个模态框 -->
		<div class="fireworks-container" v-if="showFireworks">
			<div class="firework-rocket" v-for="n in 10" :key="n"></div>
		</div>

		<div class="reward-modal-content">
			<div class="reward-modal-header gradient_background_color">
				<div class="header-decoration"></div>
				<h3>{{ $t('winning_award_text') }}</h3>
				<span class="close-btn" @click="closeRewardModal">&times;</span>
			</div>
			<div class="reward-modal-body">
				<div class="reward-image-container">
					<div class="reward-image-wrapper">
						<img :src="reward.image" :alt="reward.describe">
						<div class="reward-glow"></div>
					</div>
				</div>
				<div class="reward-info">
					<p class="reward-title">{{ reward.describe }}</p>
					<!-- <p class="reward-desc">恭喜获得奖励！</p> -->
				</div>
			</div>
			<div class="reward-modal-footer">
				<button class="confirm-btn gradient_background_color" @click="closeRewardModal">
					<span>{{ $t('confirm_text') }}</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'RewardPopup',
		data() {
			return {
				reward: {},
				showRewardModal: false,
				showFireworks: false, // 控制礼花效果显示
			}
		},
		mounted() {},
		methods: {
			show(reward) {
				this.showRewardModal = true;
				this.reward = reward;
				this.showFireworksEffect();
				let _this = this;
				setTimeout(function() {
					// _this.showRewardModal = false;
					// _this.showFireworks = false;
				}, 5000)
			},
			closeRewardModal: function() {
				this.showRewardModal = false;
				this.showFireworks = false;
			},
			// 修改显示礼花效果的方法为烟花效果
			showFireworksEffect: function() {
				this.showFireworks = true;
				// 创建烟花效果
				setTimeout(() => {
					const rockets = document.querySelectorAll('.firework-rocket');
					rockets.forEach(rocket => {
						// 随机设置烟花爆炸位置
						const left = Math.random() * 90 + 5; // 5% - 95%
						const top = Math.random() * 70 + 5; // 5% - 75%

						// 设置烟花发射起点和目标位置
						rocket.style.setProperty('--target-left', `${left}%`);
						rocket.style.setProperty('--target-top', `${top}%`);

						// 随机设置烟花颜色
						const hue = Math.floor(Math.random() * 360);
						const saturation = 80 + Math.random() * 20; // 80-100%
						const lightness = 50 + Math.random() * 10; // 50-60%
						rocket.style.setProperty('--firework-color',
							`hsl(${hue}, ${saturation}%, ${lightness}%)`);

						// 随机设置发射延迟
						const delay = Math.random() * 3;
						rocket.style.animationDelay = `${delay}s`;
					});
				}, 50);

				// 8秒后自动隐藏烟花效果
				setTimeout(() => {
					this.showFireworks = false;
				}, 8000);
			},
		}
	}
</script>
<style>
	/* 优化后的奖励弹窗样式 */
	.reward-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.75);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 10000;
		backdrop-filter: blur(3px);
	}

	.reward-modal-content {
		background: linear-gradient(to bottom, #ffffff, #f5f5f5);
		border-radius: 16px;
		width: 85%;
		max-width: 360px;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
		overflow: hidden;
		animation: modal-appear 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
		border: 1px solid rgba(255, 255, 255, 0.2);
		position: relative;
	}

	@keyframes modal-appear {
		from {
			opacity: 0;
			transform: scale(0.8) translateY(-40px);
		}

		to {
			opacity: 1;
			transform: scale(1) translateY(0);
		}
	}

	.reward-modal-header {
		color: white;
		padding: 14px 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;
		overflow: hidden;
	}

	.header-decoration {
		position: absolute;
		top: -20px;
		right: -20px;
		width: 100px;
		height: 100px;
		background: rgba(255, 255, 255, 0.15);
		border-radius: 50%;
	}

	.reward-modal-header h3 {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
		position: relative;
		z-index: 1;
	}

	.close-btn {
		font-size: 28px;
		cursor: pointer;
		color: white;
		opacity: 0.8;
		transition: opacity 0.2s;
		position: relative;
		z-index: 1;
		line-height: 0.8;
	}

	.close-btn:hover {
		opacity: 1;
	}

	.reward-modal-body {
		padding: 25px 20px 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.reward-image-container {
		margin-bottom: 20px;
		position: relative;
	}

	.reward-image-wrapper {
		width: 120px;
		height: 120px;
		background: linear-gradient(to bottom, #f9f9f9, #efefef);
		border-radius: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
		position: relative;
		overflow: hidden;
		border: 1px solid rgba(0, 0, 0, 0.05);
		animation: image-pulse 2s infinite ease-in-out;
	}

	@keyframes image-pulse {
		0% {
			box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
		}

		50% {
			box-shadow: 0 5px 25px rgba(253, 209, 0, 0.3);
		}

		100% {
			box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
		}
	}

	.reward-glow {
		position: absolute;
		top: -50%;
		left: -50%;
		width: 200%;
		height: 200%;
		background: radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 70%);
		opacity: 0;
		animation: glow-rotate 4s infinite linear;
	}

	@keyframes glow-rotate {
		0% {
			transform: rotate(0deg);
			opacity: 0;
		}

		25% {
			opacity: 0.5;
		}

		50% {
			transform: rotate(180deg);
			opacity: 0;
		}

		75% {
			opacity: 0.5;
		}

		100% {
			transform: rotate(360deg);
			opacity: 0;
		}
	}

	.reward-image-wrapper img {
		max-width: 85%;
		max-height: 85%;
		object-fit: contain;
		filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.2));
		animation: float 3s infinite ease-in-out;
		z-index: 1;
	}

	@keyframes float {

		0%,
		100% {
			transform: translateY(0);
		}

		50% {
			transform: translateY(-5px);
		}
	}

	.reward-info {
		text-align: center;
		width: 100%;
	}

	.reward-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 8px;
		color: #333;
	}

	.reward-desc {
		font-size: 14px;
		color: #666;
		margin-bottom: 5px;
	}

	.reward-modal-footer {
		padding: 15px 20px 20px;
		text-align: center;
	}

	.confirm-btn {
		color: white;
		border: none;
		padding: 11px 0;
		border-radius: 30px;
		font-size: 16px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s;
		width: 80%;
		position: relative;
		overflow: hidden;
	}

	.confirm-btn::before {
		content: '';
		position: absolute;
		top: 0;
		left: -100%;
		width: 100%;
		height: 100%;
		background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
		transition: all 0.6s;
	}

	.confirm-btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 15px rgba(253, 209, 0, 0.4);
	}

	.confirm-btn:hover::before {
		left: 100%;
	}

	.confirm-btn:active {
		transform: translateY(1px);
		box-shadow: 0 2px 5px rgba(253, 209, 0, 0.4);
	}




	/* 替换礼花效果样式为烟花效果样式 */
	.fireworks-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		z-index: 10001;
		/* 确保在模态框内容之上 */
		overflow: hidden;
	}

	.firework-rocket {
		position: absolute;
		bottom: -10px;
		width: 2px;
		/* 减小宽度 */
		height: 2px;
		/* 减小高度 */
		background-color: #fff;
		border-radius: 50%;
		z-index: 10001;
		transform-origin: center bottom;
		animation: rocket-launch 1.5s ease-out forwards;
	}

	/* 设置不同烟花的位置和颜色 */
	.firework-rocket:nth-child(1) {
		left: 20%;
		animation-delay: 0.2s;
	}

	.firework-rocket:nth-child(2) {
		left: 40%;
		animation-delay: 0.7s;
	}

	.firework-rocket:nth-child(3) {
		left: 60%;
		animation-delay: 1.2s;
	}

	.firework-rocket:nth-child(4) {
		left: 80%;
		animation-delay: 1.7s;
	}

	.firework-rocket:nth-child(5) {
		left: 30%;
		animation-delay: 2.2s;
	}

	.firework-rocket:nth-child(6) {
		left: 70%;
		animation-delay: 2.7s;
	}

	/* 添加更多烟花位置 */
	.firework-rocket:nth-child(7) {
		left: 25%;
		animation-delay: 0.5s;
	}

	.firework-rocket:nth-child(8) {
		left: 55%;
		animation-delay: 1.0s;
	}

	.firework-rocket:nth-child(9) {
		left: 85%;
		animation-delay: 1.5s;
	}

	.firework-rocket:nth-child(10) {
		left: 15%;
		animation-delay: 2.0s;
	}

	/* 烟花发射动画 - 减小爆炸效果 */
	@keyframes rocket-launch {
		0% {
			transform: translateY(0) scale(1);
			background-color: #fff;
			box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
		}

		/* 上升阶段 - 添加尾迹 */
		40% {
			transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(1);
			background-color: #fff;
			box-shadow: 0 0 3px 1px rgba(255, 255, 255, 0.8), 0 0 6px 3px rgba(255, 255, 255, 0.4);
			/* 减小尾迹 */
		}

		/* 爆炸阶段 */
		41% {
			transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(1);
			background-color: var(--firework-color, #ff5252);
			box-shadow: 0 0 3px 1px var(--firework-color, #ff5252);
			/* 减小光晕 */
		}

		/* 爆炸扩散 - 减小扩散范围 */
		43% {
			transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(10);
			/* 从15减小到10 */
			background-color: var(--firework-color, #ff5252);
			box-shadow: 0 0 12px 6px var(--firework-color, #ff5252), 0 0 24px 12px rgba(255, 255, 255, 0.4);
			/* 减小光晕 */
			opacity: 1;
		}

		/* 爆炸消失 */
		100% {
			transform: translate(calc(var(--target-left) - 50%), calc(var(--target-top) - 50vh)) scale(12);
			/* 从20减小到12 */
			background-color: var(--firework-color, #ff5252);
			box-shadow: 0 0 24px 12px rgba(255, 255, 255, 0);
			/* 减小光晕 */
			opacity: 0;
		}
	}

	/* 添加烟花粒子效果 - 增强粒子效果 */
	.firework-rocket::before,
	.firework-rocket::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: inherit;
		opacity: 0;
	}

	.firework-rocket::before {
		animation: firework-particles 1.5s ease-out 0.6s forwards;
	}

	.firework-rocket::after {
		animation: firework-particles 1.5s ease-out 0.8s forwards;
	}

	@keyframes firework-particles {
		0% {
			transform: scale(1) rotate(0deg);
			box-shadow:
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252),
				0 0 0 0px var(--firework-color, #ff5252);
			opacity: 0;
		}

		10% {
			opacity: 1;
		}

		100% {
			transform: scale(0.1) rotate(45deg);
			box-shadow:
				0 -40px 0 0px var(--firework-color, #ff5252),
				/* 从-60px减小到-40px */
				40px 0 0 0px var(--firework-color, #ff5252),
				/* 从60px减小到40px */
				0 40px 0 0px var(--firework-color, #ff5252),
				/* 从60px减小到40px */
				-40px 0 0 0px var(--firework-color, #ff5252),
				/* 从-60px减小到-40px */
				-30px -30px 0 0px var(--firework-color, #ff5252),
				/* 从-45px减小到-30px */
				30px -30px 0 0px var(--firework-color, #ff5252),
				/* 从45px减小到30px */
				30px 30px 0 0px var(--firework-color, #ff5252),
				/* 从45px减小到30px */
				-30px 30px 0 0px var(--firework-color, #ff5252);
			/* 从-45px减小到-30px */
			opacity: 0;
		}
	}
</style>